import React, { useState } from 'react';
import PageChrome from '../../components/layout/PageChrome';
import RichText from '../../components/ui/RichText';
import RoomReservationCard from '../../components/cards/RoomReservationCard';
import RoomReservationForm from '../../components/forms/RoomReservationForm';
import roomReservation from '../../cms/room-reservation.json';
import '../../css/events/RoomReservation.css';

const roomReservationInfo = roomReservation.info;
const facilityDetails = roomReservation.facilities;
const reservationPolicies = roomReservation.policies;

const RoomReservation = () => {
  const [showReservationForm, setShowReservationForm] = useState(false);

  const handleReservationClick = () => {
    setShowReservationForm(true);
  };

  const closeReservationForm = () => {
    setShowReservationForm(false);
  };

  return (
    <>
      <PageChrome
        title={roomReservationInfo.title}
        subtitle={roomReservationInfo.subtitle}
        intro={[roomReservationInfo.description, roomReservationInfo.welcomeMessage].filter(
          (item) => item != null && item !== ''
        )}
      >
        <section className="room-reservation-page-section">
          <div className="room-reservation-page-facilities">
            <h2>Our Facilities</h2>
            <div className="room-reservation-page-grid">
              {facilityDetails.map((facility) => (
                <RoomReservationCard key={facility.id} facility={facility} />
              ))}
            </div>
            <div className="room-reservation-page-cta">
              <button 
                className="room-reservation-page-button"
                onClick={handleReservationClick}
              >
                Reserve a Room
              </button>
            </div>
          </div>
          
          <div className="room-reservation-page-policies">
            <h2>Reservation Policies</h2>
            <ul>
              {reservationPolicies.map((policy, index) => (
                <li key={index}>{policy}</li>
              ))}
            </ul>
            <div className="room-reservation-page-contact">
              <RichText value={roomReservationInfo.contactNote} className="room-reservation-page-contact-note" />
            </div>
          </div>
        </section>
      </PageChrome>

      {showReservationForm && <RoomReservationForm onClose={closeReservationForm} />}
    </>
  );
};

export default RoomReservation; 